import { render, staticRenderFns } from "./RevenueShareIndex.vue?vue&type=template&id=cc0deba8&scoped=true&"
import script from "./RevenueShareIndex.vue?vue&type=script&lang=js&"
export * from "./RevenueShareIndex.vue?vue&type=script&lang=js&"
import style0 from "./RevenueShareIndex.vue?vue&type=style&index=0&id=cc0deba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0deba8",
  null
  
)

export default component.exports